import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderChapters from "./useReorderChapters";
import { txt } from "../../../services/translation";

export default function useDeleteChapter(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', id, 'chapters'], [id]);

    const reorderChapters = useReorderChapters()

    return (id) => {

        const ok = window.confirm(txt("confirmDeleteChapter"));

        if(!ok) return false;
        
        const oldChapters = [...queryClient.getQueryData(queryKey)];

        let newChapters = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== id);
        newChapters = reorderChapters(newChapters);
        queryClient.setQueryData(queryKey, newChapters);

        API.delete(`/design/chapters/${id}`)
            .then(() => API.put('/design/chapters/reorder', newChapters))
            .catch(() => {
                queryClient.setQueryData(queryKey, oldChapters)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}